const Slider = class Slider{

    constructor(){
    }

    /**
     *
     * @param slider
     * @param dots
     * @param arrows
     * @param speed
     */
    init(slider, dots = true, arrows = false, speed = 300){
        this.slider = $(slider);
        this.dots = dots;
        this.arrows = arrows;
        this.speed = speed;

        this.sliderConfig();
    }

    /**
     *
     */
    sliderConfig(){
        this.slider.slick({
            dots: this.dots,
            speed: this.speed,
            arrows: this.arrows,
            infinite: true,
            slidesToShow: 1,
            nextArrow: this.arrows ? prevArrow : '',
            prevArrow: this.arrows ? nextArrow : '',
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });
    }
};

export {Slider};


// WEBPACK FOOTER //
// ./static/js/components/Slider.js